import { memo } from 'react';

import ImportIconSVG from '@/assets/import-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IImportIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={ImportIconSVG} {...props} />;

export const ImportIcon = memo(IImportIcon) as typeof IImportIcon;
